import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../api-response';
import { BaseApiService } from '../../../core/base-api.service';
import { FeedFileDownload, FeedFileSet } from '../models/provider.model';

/** Delivered feed file sets — /api/v1/admin/feeds/{feedId}/file-sets,
 *  read-only. Core builds the sets itself from the feed's files (see
 *  `FeedFileService`); there's no upload here any more. Super-admin only, and
 *  only for feeds whose provider has `acceptsFiles` (core 400s otherwise). */
@Injectable({ providedIn: 'root' })
export class FeedFileSetService extends BaseApiService {
  private readonly http = inject(HttpClient);

  private fileSetsUrl(feedId: string): string {
    return `${this.coreApiUrl}/api/v1/admin/feeds/${feedId}/file-sets`;
  }

  /** Newest first; at most the 5 core retains. */
  getAll(feedId: string): Observable<ApiResponse<FeedFileSet[]>> {
    return this.http.get<ApiResponse<FeedFileSet[]>>(this.fileSetsUrl(feedId));
  }

  /** Fetch on click, not ahead of time — the link expires after 15 minutes. */
  getDownloadUrl(feedId: string, fileSetId: string, fileId: string): Observable<ApiResponse<FeedFileDownload>> {
    return this.http.get<ApiResponse<FeedFileDownload>>(
      `${this.fileSetsUrl(feedId)}/${fileSetId}/files/${fileId}/download-url`,
    );
  }
}
